<template>
  <v-col id="home" class="screen" cols="12" md="8">
    <div>
      <section class="main section">
        <v-card class="ma-3" v-if="!recentPresentationsLoading && empty">
          <v-card-title primary-title>
            <h3 class="headline mb-0">At-And</h3>
          </v-card-title>
          <v-card-text>
            View and save slides.<br>
            Check into the presentation you’re attending.
          </v-card-text>

          <v-card-actions>
            <router-link to="/checkin">
              <v-btn color="primary">Check-in</v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
        <div class="header-action text-center" v-if="!empty">
          <router-link to="/checkin">
            <v-btn color="primary">Check-in</v-btn>
          </router-link>
        </div>
        <div class="last-activity">
          <v-subheader v-if="!empty">Presentations</v-subheader>
          <eventlist :presentations="recentPresentationsList"/>
          <router-link to="/presentations" tag="div" v-if="tooManyPresentations">
            <v-btn flat small color="primary">View all</v-btn>
          </router-link>
        </div>
      </section>
    </div>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import eventlist from '../components/Eventlist';

export default {
  name: 'Home',
  components: {
    eventlist
  },

  created() {
    this.$store.dispatch('getResumablePresentation');
  },

  computed: {
    empty() {
      return this.recentPresentationsList && this.recentPresentationsList.length === 0;
    },
    tooManyPresentations() {
      return this.recentPresentationsList && this.recentPresentationsList.length > 3;
    },
    ...mapGetters([
      'loggedIn',
      'isNewUser',
      'recentPresentationsList',
      'recentPresentationsLoading',
      'presentationIdAfterSignIn'
    ])
  },

  watch: {
    presentationIdAfterSignIn(presentationId) {
      this.$router.push({ name: 'presentation', params: { presentationId } });
    }
  }
};
</script>

<style lang="scss">
  .header-action {
    text-align: center;
  }

  .resume-attend {
    display: block;
    margin: 0 16px 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue